export type CreationCommandTypes = 'OriginalElement' | 'NONE' | 'RepairElement' | 'CriticalAreaElement';
export type WorkCommandGeometryCreationTypes = 'UserDefined' | 'Grouped' | 'Fragmented';
export type ExecutionStatus = 'OUTLINED' | 'EXECUTED';
export class DomainEntity {
    public ID: number;
    public Guid: string;
    public TempGuid: string;
    public Name: string;
}